import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ATS_ActionProcessor.scss';
import { _keys } from '@nu-art/ts-common';
import { Dialog_ActionProcessorConfirmation } from '../dialogs/index.js';
import { ComponentAsync } from '../../core/ComponentAsync.js';
import { ATS_Backend, TS_AppTools } from '../../components/TS_AppTools/index.js';
import { ModuleFE_ActionProcessor } from '../../modules/action-processor/ModuleFE_ActionProcessor.js';
import { genericNotificationAction } from '../../components/TS_Notifications/index.js';
import { LL_H_C, LL_V_L } from '../../components/Layouts/index.js';
import { Button } from '../../components/Button/Button.js';
export class ATS_ActionProcessor extends ComponentAsync {
    static screen = { name: 'Refactoring Actions', key: 'refactoring-actions', renderer: this, group: ATS_Backend };
    // ######################### Life Cycle #########################
    async deriveStateFromProps(nextProps) {
        const state = this.state ? { ...this.state } : {};
        state.actions = await ModuleFE_ActionProcessor.vv1.list({}).executeSync();
        state.actionsInProgress ??= [];
        return state;
    }
    // ######################### Logic #########################
    onButtonClick = async (action) => {
        return Dialog_ActionProcessorConfirmation.show(action, async () => {
            await genericNotificationAction(async () => {
                this.setState({ actionsInProgress: [...this.state.actionsInProgress, action.key] });
                await ModuleFE_ActionProcessor.vv1.execute({ key: action.key }).executeSync();
            }, { inProgress: `Executing ${action.key}`, success: `${action.key} - Success`, failed: `${action.key} - Failure` });
            this.setState({ actionsInProgress: this.state.actionsInProgress.filter(i => i !== action.key) });
        });
    };
    // ######################### Render #########################
    renderButtons(actionGroup) {
        return _jsx(LL_H_C, { className: 'action-group__buttons', children: actionGroup.map(action => {
                return _jsx(Button, { onClick: () => this.onButtonClick(action), disabled: this.state.actionsInProgress.includes(action.key), children: action.key.replace(/-/g, ' ') }, action.key);
            }) });
    }
    renderButtonGroups() {
        const groups = this.state.actions?.reduce((acc, curr) => {
            if (!acc[curr.group])
                acc[curr.group] = [];
            acc[curr.group].push(curr);
            return acc;
        }, {});
        if (!groups)
            return '';
        return _jsx(LL_V_L, { className: 'action-groups', children: _keys(groups).map(key => {
                return _jsxs(LL_V_L, { className: 'action-group', children: [_jsx("div", { className: 'action-group__title', children: key }), this.renderButtons(groups[key])] }, key);
            }) });
    }
    render() {
        return _jsxs("div", { className: 'refactoring-actions-page', children: [TS_AppTools.renderPageHeader('Refactoring Actions'), this.renderButtonGroups()] });
    }
}
//# sourceMappingURL=ATS_ActionProcessor.js.map